import axios from "axios";
import { getStoreModuleContext } from "~/utils/store";
import { getAccessToken } from "~/lib/hostAppData";

function storeAccessToken() {
  const accessToken = getAccessToken();

  if (!accessToken) return;

  const authStore = getStoreModuleContext("auth");
  authStore.commit("setAccessToken", accessToken);

  return accessToken;
}

function setAxiosCommonHeader(accessToken) {
  const axiosDefaultCommonHeaders = axios.defaults.headers.common;

  if (accessToken) axiosDefaultCommonHeaders["jwt"] = accessToken;
  else delete axiosDefaultCommonHeaders["jwt"];
}

export default function () {
  const accessToken = storeAccessToken();
  setAxiosCommonHeader(accessToken);
}
